import { UserGeneralConfig } from '@/types_cp/user/settings';

export const DEFAULT_COMMON_SETTINGS: UserGeneralConfig = {
  fontSize: 14,
  highlighterTheme: 'lobe-theme',
  mermaidTheme: 'lobe-theme',
  transitionMode: 'fadeIn',
};
